<template>
  <b-container style="width:600px;">
    <b-card>
      <h3>Check Email</h3>
      <br/>
      <b-card-text>
        <b-input-group prepend="Email">
          <b-form-input trim autocomplete="off" v-model="form.email" @keyup.enter="getEnrollments"
                        type="text"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="getEnrollments">Submit
              <b-spinner v-if="this.isSending" class="m-1" label="Spinning" small/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <ul class="mt-3">
          <li v-for="error in email_errors" :key="error" style="color:red">{{ error }}</li>
        </ul>
        <div v-if="enrollments.length">
          <b>Enrollments:</b>
          <ol class="pl-3 pt-1">
            <li v-for="enrollment in enrollments" :key="enrollment.token">
              <a class="position-relative" :href="'/course/' + enrollment.lti_course.context_id">{{
                  enrollment.lti_course.context_title ? enrollment.lti_course.context_title : 'N/A'
                }}
              </a>
              <span v-b-tooltip.hover :title="enrollment.lti_course.canvas_domain" class="badge border border-muted text-muted">url</span>
              <span v-b-tooltip.hover :title="new Date(enrollment.updated_at).toLocaleString()" v-if="enrollment.is_processed">
                <router-link :to="`/token?token=${enrollment.token}`" class="ml-1 badge border border-success text-success">p</router-link>
              </span>
              <span v-else>
                <router-link :to="`/token?token=${enrollment.token}`" class="badge border border-muted text-muted">p</router-link>
              </span>
              <span v-b-tooltip.hover
                :title="(enrollment.coupons.length > 0 ? enrollment.coupons[0].coupon_code : enrollment.stripe_event_id ? 'stripe' : '')"
                v-if="enrollment.coupons.length > 0 || enrollment.stripe_event_id"
                class="ml-1 badge border border-secondary text-secondary">
                {{ enrollment.coupons.length > 0 ? 'coupon' : enrollment.stripe_event_id ? 'stripe' : '' }}
              </span>
              <small class="ml-2 text-muted" v-b-tooltip.hover :title="new Date(enrollment.created_at).toLocaleString()">
                {{ enrollment.created_at | date }}
              </small>

            </li>
          </ol>
        </div>
        <div v-if="memberships.length">
          <b>LTI 1.3 Enrollments:</b>
          <ol class="pl-3 pt-1">
            <li v-for="membership in memberships" :key="membership.token">
              {{ membership.context.context_title ? membership.context.context_title : 'N/A' }}
              <span v-b-tooltip.hover :title="membership.context.deployment.credential.platform.iss.slice(8)" class="badge border border-muted text-muted">url</span>
              <span v-b-tooltip.hover :title="membership.role" class="ml-1 badge border border-muted text-muted">{{membership.role.charAt(0)}}</span>
              <span v-b-tooltip.hover :title="new Date(membership.processed_at).toLocaleString()" v-if="membership.processed_at" >
                <router-link :to="`/token?token=${membership.token}`" class="ml-1 badge border border-success text-success">p</router-link>
              </span>
              <span v-else>
                <router-link :to="`/token?token=${membership.token}`" class="badge border border-muted text-muted">p</router-link>
              </span>
              <span v-b-tooltip.hover
                :title="(membership.coupon ? membership.coupon.coupon_code : membership.stripe_event_id ? 'stripe' : '')"
                v-if="membership.coupon || membership.stripe_event_id"
                class="ml-1 badge border border-secondary text-secondary">
                {{ membership.coupon ? 'coupon' : membership.stripe_event_id ? 'stripe' : '' }}
              </span>
              <small class="ml-2 text-muted" v-b-tooltip.hover :title="new Date(membership.created_at).toLocaleString()">
                {{ membership.created_at | date }}
              </small>
            </li>
          </ol>
        </div>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import {getEnrollments, getMemberships} from "../../utils/twa-api"

export default {
  data() {
    return {
      form: {
        email: this.$route.params.email
      },
      isSending: false,
      email_errors: [],
      enrollments: [],
      memberships: [],
      hasError: false
    }
  },
  methods: {
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    async getEnrollments() {
      this.isSending = true
      this.enrollments = []
      this.memberships = []
      this.email_errors = []
      this.hasError = false
      try {
        this.enrollments = await getEnrollments(this.form.email)
        console.log('Enrollments', this.enrollments)
      } catch (error) {
        this.hasError = true;
        if (error.response && error.response.status === 404) {
          this.email_errors.push("Enrollments not found");
        } else if (error.response && error.response.status === 500) {
          this.email_errors.push("Internal Server Error");
        } else if (error.response && error.response.status === 401) {
          this.email_errors.push("Unauthorized. Try refreshing or log out then log back in.")
        } else {
          console.log(error)
        }
      }
      try {
        this.memberships = await getMemberships(this.form.email)
        console.log('Memberships', this.memberships)
      } catch (error) {
        this.hasError = true;
        if (error.response && error.response.status === 404) {
          this.email_errors.push("Memberships not found");
        } else if (error.response && error.response.status === 500) {
          this.email_errors.push("Internal Server Error");
        } else if (error.response && error.response.status === 401) {
          this.email_errors.push("Unauthorized. Try refreshing or log out then log back in.")
        } else {
          console.log(error)
        }
      }
      if (this.hasError == false && this.enrollments.length == 0 && this.memberships.length == 0) {
        this.email_errors.push("No enrollments and memberships associated with the email found")
      }
      this.isSending = false
    },
  }
}
</script>